import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {Login} from 'arkulpa-fec';
import config from '../config';

const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      _id
      token
    }
  }
`;

const LOGIN_MUTATION_CONFIG = {
  props: ({mutate}) => ({
    login(variables) {
      return mutate({
        variables,
        update: (_, {data: {login}}) => config.writeAuthToken(login.token)
      });
    }
  })
};

const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

const FORGOT_PASSWORD_MUTATION_CONFIG = {
  name: 'forgotPassword'
};

export default compose(
  graphql(LOGIN_MUTATION, LOGIN_MUTATION_CONFIG),
  graphql(FORGOT_PASSWORD_MUTATION, FORGOT_PASSWORD_MUTATION_CONFIG)
)(Login);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js